<template>
  <div class="searchPage">
    <div class="ulList" v-if="selectTypeShow">
      <ul class="clearfix">
        <!-- <li>
          <dl @click="getUrl(zq)">
            <dt>
              <img :src="baseUrl + 'searchImg/zhengqu.png'" />
            </dt>
            <dd>{{ $t("common.politicalTit") }}</dd>
          </dl>
        </li> -->
        <li>
          <dl @click="getUrl(zrq)">
            <dt>
              <img :src="baseUrl + 'searchImg/zerenqu.png'" />
            </dt>
            <dd>{{ $t("linLongMsg.baseMapTit") }}</dd>
          </dl>
        </li>
        <li v-if="showTask">
          <dl @click="getUrl(rw)">
            <dt>
              <img :src="baseUrl + 'searchImg/renwu.png'" />
            </dt>
            <dd>{{ $t("common.taskTit") }}</dd>
          </dl>
        </li>
        <!-- <li>
                <dl @click="getUrl(lz)">
                    <dt><img :src="baseUrl+'searchImg/linzhang.png'" /></dt>
                    <dd>林长</dd>
                </dl>
        </li>-->
        <li>
          <dl @click="getUrl(gs)">
            <dt>
              <img :src="baseUrl + 'searchImg/gushumingmu.png'" />
            </dt>
            <dd>{{ $t("searchMsg.gushumingmuTit") }}</dd>
          </dl>
        </li>
        <li>
          <dl @click="getUrl(ld)">
            <dt>
              <img :src="baseUrl + 'searchImg/lindi.png'" />
            </dt>
            <dd>{{ $t("searchMsg.lindiTit") }}</dd>
          </dl>
        </li>
        <li>
          <dl @click="getUrl(sd)">
            <dt>
              <img :src="baseUrl + 'searchImg/shidigongyuan.png'" />
            </dt>
            <dd>{{ $t("searchMsg.shidiTit") }}</dd>
          </dl>
        </li>
        <li>
          <dl @click="getUrl(zrbhd)">
            <dt>
              <img :src="baseUrl + 'searchImg/ziranbaohuqu.png'" />
            </dt>
            <dd>{{ $t("searchMsg.zrbhdTit") }}</dd>
          </dl>
        </li>
        <li>
          <dl @click="getUrl(sthx)">
            <dt>
              <img :src="baseUrl + 'searchImg/shengtaihongxian.png'" />
            </dt>
            <dd>{{ $t("searchMsg.sthxTit") }}</dd>
          </dl>
        </li>
        <li>
          <dl @click="getUrl(fx)">
            <dt>
              <img :src="baseUrl + 'searchImg/faxian.png'" />
            </dt>
            <dd>{{ $t("searchMsg.findTit") }}</dd>
          </dl>
        </li>
        <li>
          <dl @click="getUrl(jcd)">
            <dt>
              <img :src="baseUrl + 'searchImg/jiancedian.png'" />
            </dt>
            <dd>{{ $t("searchMsg.jancedianTit") }}</dd>
          </dl>
        </li>
        <li>
          <dl @click="getUrl(gsp)">
            <dt>
              <img :src="baseUrl + 'searchImg/gongshipai.png'" />
            </dt>
            <dd>{{ $t("searchMsg.gongshipaiTit") }}</dd>
          </dl>
        </li>
        <li>
          <dl @click="getUrl(yzld)">
            <dt>
              <img :src="baseUrl + 'searchImg/yingzaolin.png'" />
            </dt>
            <dd>营造林地</dd>
          </dl>
        </li>
      </ul>
      <van-divider />
      <ul class="clearfix">
        <li>
          <dl @click="getUrl(gspj)">
            <dt>
              <img :src="baseUrl + 'searchImg/gushupingj.png'" />
            </dt>
            <dd>{{ $t("searchMsg.gspjTit") }}</dd>
          </dl>
        </li>
        <li>
          <dl @click="getUrl(ldpj)">
            <dt>
              <img :src="baseUrl + 'searchImg/lindipingjai.png'" />
            </dt>
            <dd>{{ $t("searchMsg.ldpjTit") }}</dd>
          </dl>
        </li>
      </ul>
    </div>

    <!-- <search-area
      v-if="this.searchShowProp == 'searchArea'"
      @changeType="setSearchShow"
      @getMapOptions="setMapOptions"
    ></search-area> -->
    <search-billboard
      v-if="this.searchShowProp == 'searchBillboard'"
      @changeTypeOne="setSearchShow"
      @getMapOptions="setMapOptions"
    ></search-billboard>
    <search-duty-area
      v-if="this.searchShowProp == 'searchDutyArea'"
      @changeType="setSearchShow"
      @getMapOptions="setMapOptions"
    ></search-duty-area>
    <search-find
      v-if="this.searchShowProp == 'searchFind'"
      @changeType="setSearchShow"
      @getMapOptions="setMapOptions"
    ></search-find>
    <search-lin-forest
      v-if="this.searchShowProp == 'searchLinForest'"
      @changeType="setSearchShow"
      @getMapOptions="setMapOptions"
    ></search-lin-forest>
    <search-linlong-assess
      v-if="this.searchShowProp == 'searchlinLongAssess'"
      @changeType="setSearchShow"
      @getMapOptions="setMapOptions"
    ></search-linlong-assess>
    <search-monitor
      v-if="this.searchShowProp == 'searchMonitor'"
      @changeType="setSearchShow"
      @getMapOptions="setMapOptions"
    ></search-monitor>
    <search-old-tree
      v-if="this.searchShowProp == 'searchOldTree'"
      @changeType="setSearchShow"
      @getMapOptions="setMapOptions"
    ></search-old-tree>
    <search-old-tree-assess
      v-if="this.searchShowProp == 'searchOldTreeAssess'"
      @changeType="setSearchShow"
      @getMapOptions="setMapOptions"
    ></search-old-tree-assess>
    <search-sthx
      v-if="this.searchShowProp == 'searchSthx'"
      @changeType="setSearchShow"
      @getMapOptions="setMapOptions"
    ></search-sthx>
    <search-wetland
      v-if="this.searchShowProp == 'searchWetland'"
      @changeType="setSearchShow"
      @getMapOptions="setMapOptions"
    ></search-wetland>
    <search-zrbhd
      v-if="this.searchShowProp == 'searchZrbhd'"
      @changeType="setSearchShow"
      @getMapOptions="setMapOptions"
    ></search-zrbhd>
    <search-task
      v-if="this.searchShowProp == 'searchTask'"
      @changeType="setSearchShow"
      @getMapOptions="setMapOptions"
    ></search-task>
    <search-personnel
      v-if="this.searchShowProp == 'searchPersonnel'"
      @changeType="setSearchShow"
      @getMapOptions="setMapOptions"
    ></search-personnel>
    <search-yzld
      v-if="this.searchShowProp == 'searchYzld'"
      @changeType="setSearchShow"
      @getMapOptions="setMapOptions"
    ></search-yzld>
  </div>
</template>
<script>
/*eslint-disable*/
const searchArea = () => import("@/views/search/searchArea");
const searchBillboard = () => import("@/views/search/searchBillboard");
const searchDutyArea = () => import("@/views/search/searchDutyArea");
const searchFind = () => import("@/views/search/searchFind");
const searchLinForest = () => import("@/views/search/searchLinForest");
const searchLinlongAssess = () => import("@/views/search/searchlinLongAssess");
const searchMonitor = () => import("@/views/search/searchMonitor");
const searchOldTree = () => import("@/views/search/searchOldTree");
const searchOldTreeAssess = () => import("@/views/search/searchOldTreeAssess");
const searchPersonnel = () => import("@/views/search/searchPersonnel");
const searchSthx = () => import("@/views/search/searchSthx");
const searchTask = () => import("@/views/search/searchTask");
const searchWetland = () => import("@/views/search/searchwetland");
const searchZrbhd = () => import("@/views/search/searchZrbhd");
const searchYzld = () => import("@/views/search/searchYzld");

// import { getToken } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
// import SearchYzld from './searchYzld.vue';
export default {
  name: "search",
  //是否展示任务。默认展示
  props: {
    showTask: { type: Boolean, default: true },
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      userUid: "",
      zq: "searchArea",
      zrq: "searchDutyArea",
      rw: "searchTask",
      lz: "searchPersonnel",
      gs: "searchOldTree",
      ld: "searchLinForest",
      sd: "searchWetland",
      zrbhd: "searchZrbhd",
      sthx: "searchSthx",
      fx: "searchFind",
      jcd: "searchMonitor",
      gsp: "searchBillboard",
      yzld: "searchYzld",
      gspj: "searchOldTreeAssess",
      ldpj: "searchlinLongAssess",
      selectTypeShow: true,
      searchShow: false,
      showPackPicker: false,
      searchShowProp: "", //显示的组件
      clientType: "", //手机类型
    };
  },
  mounted() {
    this.clientType = getDeviceType();
    this.$store.commit("SetcloseShowType", "open");
  },
  components: {
    searchArea,
    searchBillboard,
    searchDutyArea,
    searchFind,
    searchLinForest,
    searchLinlongAssess,
    searchMonitor,
    searchOldTree,
    searchOldTreeAssess,
    searchPersonnel,
    searchSthx,
    searchTask,
    searchWetland,
    searchZrbhd,
    searchYzld,
  },
  methods: {
    getUrl(address) {
      let _this = this;
      _this.searchShow = true;
      _this.selectTypeShow = false;
      _this.searchShowProp = address;
      //  _this.$store.commit("SetcloseShowType", 'close');
    },
    setSearchShow(type) {
      this.selectTypeShow = type;
      this.searchShowProp = "";
      this.$store.commit("SetcloseShowType", "open");
    },
    setMapOptions(data) {
      
      this.$emit(
        "onLocate",
        data.objid,
        data.type,
        data.postionMsg ? data.postionMsg : ""
      );
    },
  },
};
</script>
<style lang="less" scoped>
.searchPage {
  width: 100%;
  height: 100%;
  h4 {
    margin-top: 10px;
    font-size: 14px;
    line-height: 18px;
    color: #666;
  }

  ul {
    margin-top: 10px;

    li {
      float: left;
      width: 33%;
      margin: 10px 0;

      dl {
        width: 100%;
        position: relative;

        dt {
          display: block;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          -webkit-border-radius: 50%;
          -moz-border-radius: 50%;
          background-color: #f6f6f6;
          margin: 0 auto;

          img {
            width: 100%;
            height: 100%;
          }
        }

        dd {
          display: block;
          width: 100%;
          text-align: center;
          color: #666;
          margin-top: 10px;
        }
      }
    }
  }
  /* .searchProp{
            height: 68%;
             
        } */
}
</style>